module.exports = "<img [src]=\"photo\" />\n"